/* eslint-disable import/prefer-default-export */
const prefix = 'tags'

export const SET_TAGS = `${prefix}/SET_TAGS`
